import React, { useEffect, useState, useRef } from 'react';
import Clock, { Block, UnBlock } from '../../assets/svg.js';
import { RightArrow, Dots } from '../../assets/svg.js';
import { Nav, NavItem, NavLink } from 'reactstrap';
import './UsersList.css';
import apiService from '../../services/apiService.js';
import ConfiramtionModal from './ConfiramtionModal.js';
import { useNavigate } from 'react-router-dom';
import selectBox from '../../assets/images/select-box-circle-fill (1).svg';
import circle from '../../assets/images/indeterminate-circle-fill.svg';
import pending from '../../assets/images/time-fill.svg';
import { toast } from 'react-toastify';
import DataTableReact from '../../components/common/datatable/DataTableReact.jsx';
import { Menu, MenuItem } from '@mui/material';
import debounce from 'lodash.debounce';
import CustomDropDown from '../../components/common/dropdown/Dropdown.jsx';
import useMedicalSpecialties from 'components/common/medSpecialty/MedicalSpecialty.jsx';
import time from '../../assets/icons/time-fill.svg';

const actionStatuses = [
  { value: 'Approved', label: 'Approved' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Rejected', label: 'Rejected' },
];

const medicalSpecialties = [
  { value: 'Cardiology', label: 'Cardiology' },
  { value: 'Dermatology', label: 'Dermatology' },
  { value: 'Neurology', label: 'Neurology' },
  { value: 'Pediatrics', label: 'Pediatrics' },
  { value: 'Psychiatry', label: 'Psychiatry' },
  { value: 'Obstetrics-and-gynecology', label: 'Obstetrics and Gynecology' },
  { value: 'Orthopedics', label: 'Orthopedics' },
  { value: 'Radiology', label: 'Radiology' },
  { value: 'Gastroenterology', label: 'Gastroenterology' },
  { value: 'Pulmonology', label: 'Pulmonology' },
  { value: 'Hematology', label: 'Hematology' },
  { value: 'Urology', label: 'Urology' },
  { value: 'Ophthalmology', label: 'Ophthalmology' },
  { value: 'Nephrology', label: 'Nephrology' },
  { value: 'Rheumatology', label: 'Rheumatology' },
];

const UserListing = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');
  const [Pagination, setPaginaton] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [prevPageUrl, setPrevPageUrl] = useState(null);
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [loading, setloading] = useState(false);
  const dropdownOpenRef = useRef();
  dropdownOpenRef.current = dropdownOpen;
  const [users, setUsers] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState({
    action: '',
    userId: '',
  });
  const [refresh, setRefresh] = useState(false);
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleRefresh = () => {
    setRefresh((pre) => !pre);
  };

  const fetchFilteredUsers = async (updatedFilters, page, rowsPerPage) => {
    try {
      setloading(true);
      const payload = {
        user_english_name: String(
          updatedFilters.user_english_name || ''
        ).toLowerCase(),
        user_arabic_name: String(
          updatedFilters.user_arabic_name || ''
        ).toLowerCase(),
        medicalSpecialties: String(
          updatedFilters.medicalSpecialties
            ?.map(({ label, value }) => ({ value }))
            .join(', ') || ''
        ),
        actionStatus: String(updatedFilters.actionStatus || '').toLowerCase(),
      };
      const response = await apiService.get(
        `physician/allPhysician?page=${page}&per_page=${rowsPerPage}`,
        payload
      );
      if (response?.original?.data?.data) {
        setUsers(response?.original?.data?.data);
        setPaginaton(response?.original);
        setTotalRows(response?.original?.pagination?.total);
        setPrevPageUrl(response?.original?.data?.next_page_url);
        setNextPageUrl(response?.original?.data?.next_page_url);
        setloading(false);
      } else {
        setUsers([]);
      }
    } catch (e) {
      console.log('Error fetching users:', e);
    }
  };

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (dropdownOpenRef.current.length != 0) {
        setDropdownOpen([]);
      }
    };

    // Attach listener
    document.addEventListener('click', handleDocumentClick);

    return () => {
      // Cleanup listener on unmount
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 2000);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    if (debouncedQuery !== '') {
      fetchFilteredUsers(debouncedQuery);
    } else {
      setUsers([]);
    }
  }, [debouncedQuery]);

  useEffect(() => {
    fetchFilteredUsers();
  }, [refresh]);

  const handleClose = () => {
    setConfirmationModal({ action: '', userId: '' });
  };

  const detailForm = (e) => {
    navigate(`/detail-form/${e.physician._id}`);
  };

  const handleSubmit = async () => {
    if (confirmationModal.userId) {
      try {
        const response = await apiService.post(
          `physician/physicianAction/${confirmationModal.userId}`,
          { action: confirmationModal.action, reason: '' }
        );
        fetchFilteredUsers(filters, page, rowsPerPage);

        if (response) {
          toast.success(response.message, { toastId: '11w' });
          handleClose();
          handleRefresh();
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  const columns = [
    {
      id: 'user_id',
      header: 'User ID',

      Cell: ({ row }) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {' '}
            {row?.original?.physician?.identityNumber || '--'}
          </span>
        );
      },
    },
    {
      id: 'Arabic Name',
      header: 'Arabic Name',

      Cell: ({ row }) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {' '}
            {row?.original?.physician?.firstArabicName || '--'}
          </span>
        );
      },
    },
    {
      header: 'English Name',

      Cell: ({ row }) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.original?.firstName}
          </span>
        );
      },
    },
    {
      header: 'Speciality',
      Cell: ({ row }) => {
        const specialties =
          row?.original?.physician?.medicalSpecialties ||
          row?.original?.physician?.related_medical_specialties;
        return (
          <span
            key={specialties?.[0]?._id}
            className="bg-[#EEEBFF] text-[#2B1664] flex items-center justify-center px-2 py-0.5 rounded-full  text-center font-inter text-xs font-medium leading-[16px]"
          >
            {specialties?.[0]?.name
              ? specialties?.[0]?.name?.charAt(0)?.toUpperCase() +
                specialties?.[0]?.name?.slice(1)
              : specialties?.[0]?.charAt(0)?.toUpperCase() +
                specialties?.[0]?.slice(1)}
          </span>
        );

        // <span className="d-none d-md-table-cell">{row?.original?.physician?.medicalSpecialties}</span>
      },
    },
    {
      header: 'Registered At',
      Cell: ({ row }) => {
        let givenDate;

        if (row?.original?.physician?.created_at) {
          givenDate = new Date(
            new Date(row?.original?.physician?.created_at)
              ?.toISOString()
              ?.split('T')[0]
          );
        } else {
          givenDate = new Date(new Date()?.toISOString()?.split('T')[0]);
        }

        // Format the date
        const day = givenDate?.getDate();
        const month = givenDate?.toLocaleString('en-US', { month: 'short' });
        const year = givenDate?.getFullYear() - 1; // Adjusting the year to 2024

        const formattedDate = `${day} ${month.toLowerCase()} ${year}`;
        return (
          <span className="font-sans font-[400] text-[14px] text-[#0A0D14]">
            {formattedDate}
          </span>
        );
      },
    },
    {
      header: 'Status',
      accessorKey: 'status',

      Cell: ({ row }) => {
        let statusToReturn = {
          approved: {
            icon: selectBox,
            text: 'Approved',
          },
          rejected: {
            icon: circle,
            text: 'Rejected',
          },
          blocked: {
            icon: circle,
            text: 'Blocked',
          },
          pending: {
            icon: pending,
            text: 'Pending',
          },
        };
        return (
          <span className="flex justify-center px-[10px] py-[6px] items-center gap-[4px] rounded-md border border-[#E2E4E9] bg-white text-[#525866] font-inter text-xs font-medium leading-4 tracking-[0.02em]">
            {statusToReturn[row?.original?.physician?.actionStatus]?.icon && (
              <img
                src={
                  statusToReturn[row?.original?.physician?.actionStatus]?.icon
                }
                alt="status"
                className="w-[16px] h-[16px]"
              />
            )}{' '}
            <p className="m-0 self-center">
              {statusToReturn[row?.original?.physician?.actionStatus]?.text}
            </p>
            {/* {row?.physician?.actionStatus ? (
              row?.physician?.actionStatus === "approved" ? (
                <>
                  <img src={selectBox} alt="logo" className="status-icon" />
                  <span className="font-sans font-medium text-[14px]] text-[#525866]">
                    {" "}
                    {capitalizeFirstCharacter(row?.physician?.actionStatus)}
                  </span>
                </>
              ) : row?.physician?.actionStatus === "rejected" ? (
                <>
                  <img src={circle} alt="logo" className="status-icon" />
                  <span className="font-sans font-medium text-[14px] text-[#525866]">
                    {" "}
                    {capitalizeFirstCharacter(row?.physician?.actionStatus)}
                  </span>
                </>
              ) : row?.physician?.actionStatus === "blocked" ? (
                <>
                  <img src={circle} alt="logo" className="status-icon" />
                  <span className="font-sans font-medium text-[14px] text-[#525866]">
                    {" "}
                    {capitalizeFirstCharacter(row?.physician?.actionStatus)}
                  </span>
                </>
              ) : (
                <>
                  <Clock className="status-icon" />
                  <span className="font-sans font-medium text-[14px] text-[#525866]">
                    {" "}
                    {capitalizeFirstCharacter(row?.physician?.actionStatus)}
                  </span>
                </>
              )
            ) : (
              "-"
            )} */}
          </span>
        );
      },
    },
  ];

  const capitalizeFirstCharacter = (str) => {
    if (!str) return ''; // Handle empty or undefined strings
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openRowId, setOpenRowId] = React.useState(null);

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget); // Set the anchor element for the clicked row
    setOpenRowId(rowId); // Set the open row ID to track which menu is open
  };

  const handleCloseTableModal = () => {
    setAnchorEl(null); // Close the menu
    setOpenRowId(null); // Reset the open row ID
  };

  const renderRowActions = ({ row, table }) => {
    const isOpen = openRowId === row.index;
    const isBlocked = row?.original?.physician?.actionStatus === 'blocked';

    return (
      <>
        <div className="flex gap-3">
          <Dots
            className="action-icon"
            onClick={(e) => handleClick(e, row?.index)}
          />
          <RightArrow
            className="action-icon"
            onClick={() => detailForm(row?.original)}
          />
        </div>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={isOpen}
          onClose={handleCloseTableModal}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          sx={{
            boxShadow: 'none', // Removing box shadow
          }}
        >
          <MenuItem
            sx={{
              fontSize: '18px',
              padding: '12px 24px',
              minWidth: '200px',
              borderRadius: '16px',
            }}
          >
            {isBlocked ? (
              <div
                className="flex"
                onClick={() => {
                  setConfirmationModal({
                    action: 'unblock',
                    userId: row?.original?.physician._id,
                  });
                  handleCloseTableModal();
                }}
              >
                <UnBlock width="30px" height="30px" />
                <span style={{ paddingLeft: '16px', color: '#38C793' }}>
                  Unblock
                </span>
              </div>
            ) : (
              <div
                className="flex"
                onClick={() => {
                  setConfirmationModal({
                    action: 'block',
                    userId: row?.original?.physician._id,
                  });
                  handleCloseTableModal();
                }}
              >
                <Block width="30px" height="30px" />
                <span style={{ paddingLeft: '16px', color: '#DF1C41' }}>
                  Block
                </span>
              </div>
            )}
          </MenuItem>
        </Menu>
      </>
    );
  };

  const handleRenderRowActions = ({ row, table }) =>
    renderRowActions({ row, table });

  const [filters, setFilters] = useState({
    user_english_name: '',
    user_arabic_name: '',
    medicalSpecialties: [],
    actionStatus: '',
  });

  // Debounce handler for the filters
  const handleDebouncedChange = debounce(
    (updatedFilters, page, rowsPerPage) => {
      setloading(true);

      const payload = {
        user_english_name: String(
          updatedFilters.user_english_name || ''
        ).toLowerCase(),
        user_arabic_name: String(
          updatedFilters.user_arabic_name || ''
        ).toLowerCase(),
        medicalSpecialties: String(
          updatedFilters.medicalSpecialties
            ?.map((label) => label?.label)
            .join(', ') || ''
        ),
        actionStatus: String(updatedFilters.actionStatus || '').toLowerCase(),
      };

      // Use apiService to send the API request
      apiService
        .get(`physician/allPhysician?per_page=${rowsPerPage}`, payload)
        .then((response) => {
          setUsers(response?.original?.data?.data || []);

          setTotalRows(response?.original?.pagination?.total);

          setloading(false);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    },
    500
  );

  // Update filters and trigger debounced change
  const handleInputChange = (e) => {
    let value;
    let name;

    if (e !== null && e.target) {
      // Standard input or select element
      const { name: inputName, value: inputValue } = e.target;
      name = inputName;
      value = inputValue;
    } else {
      // Custom component like react-select
      name = 'actionStatus'; // Assuming custom component passes 'name'
      value = e; // Assuming value is passed in a custom event object
      if (Array.isArray(value)) {
        name = 'medicalSpecialties'; // Assign to medicalSpecialties
        value = value.map((item) => item);
      } else {
        console.log("It's not an array.", value);
      }
    }

    // Handle special case for 'medicalSpecialties' (if it's a comma-separated list)
    const updatedFilters = {
      ...filters,
      [name]:
        name === 'medicalSpecialties'
          ? value?.map(({ label, value }) => ({ label, value })) || []
          : value,
    };
    setFilters(updatedFilters);
    // Trigger the debounced API call
    handleDebouncedChange(updatedFilters, page, rowsPerPage);
  };

  // Callback function to receive data from MedicalSpecialty
  const medSp = useMedicalSpecialties();

  useEffect(() => {
    // Cleanup the debounce function on unmount
    return () => handleDebouncedChange.cancel();
  }, []);

  useEffect(() => {
    fetchFilteredUsers(filters, page, rowsPerPage);
  }, [page, rowsPerPage]);

  return (
    <div className="bg-white">
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center p-4 bg-gray-100 h-[60px]">
        <div className="grid grid-cols-4 gap-4">
          {/* English Name */}
          <input
            type="text"
            name="user_english_name"
            placeholder="Enter English Name"
            value={filters.user_english_name}
            onChange={(e) => {
              const regex = /^[A-Za-z]*$/; // Only allows uppercase and lowercase English letters
              if (regex.test(e.target.value)) {
                handleInputChange(e, page, rowsPerPage); // Update state if input is valid
              }
            }}
            className="px-3 py-[4px] border border-gray-300 rounded-[12px] focus:outline-none focus:ring-0 focus:bg-transparent"
          />

          {/* Arabic Name */}
          <input
            type="text"
            name="user_arabic_name"
            placeholder="Enter Arabic Name"
            value={filters.user_arabic_name}
            onChange={(e) => {
              const regex = /^[\u0600-\u06FF\s]*$/; // Allows Arabic characters and spaces
              if (regex.test(e.target.value)) {
                handleInputChange(e, page, rowsPerPage); // Update state if input is valid
              }
            }}
            className="px-3 py-[4px] border border-gray-300 rounded-[12px] focus:outline-none focus:ring"
          />

          {/* Medical Specialties 
          <input
            type="text"
            name="medicalSpecialties"
            placeholder="Enter Specialties (comma-separated)"
            value={filters.medicalSpecialties.join(', ')}
             onChange={(e) => {={handleInputChange(e, page, rowsPerPage); }}
            className="px-3 py-2 border border-gray-300 rounded-[12px] focus:outline-none focus:ring "
          />*/}

          {/* Action Status */}

          <CustomDropDown
            name="medicalSpecialties"
            value={
              filters.medicalSpecialties?.map((site) => ({
                label: site?.label,
                value: site?.value,
              })) || []
            }
            onFieldSelect={(e) => {
              handleInputChange(e);
            }}
            options={
              medSp?.map(({ name, _id, ...rest }) => ({
                label: name,
                value: _id,
                ...rest,
              })) || []
            }
            zIndex={'99999'}
            isMulti={true}
          />

          <CustomDropDown
            name="actionStatus"
            value={filters.actionStatus}
            onChange={handleInputChange}
            options={actionStatuses}
            zIndex={'99999'}
          />
        </div>
        {/* <div className="grid grid-cols-2 divide-x-4"> */}
        {/* <div className="d-flex align-items-center">
            <Button color="light" className="me-2 opacity-20	">
              <BiTrash className="text-xl	" />
            </Button>
            <Button color="light" className="me-3">
              <BiArrowToBottom className="text-xl	" />
            </Button>
          </div> */}
        <p className="text-black text-right font-inter text-xs font-medium leading-[18px] tracking-[0.36px] self-center m-0">
          Total Count: {Pagination?.pagination?.total}
        </p>

        {/* </div> */}
      </div>

      {/* <div className="p-4 bg-white shadow-md rounded-lg">
        Apply Filters Button 
        <button
          onClick={() => handleDebouncedChange(filters,page,rowsPerPage)}
          className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
        >
          Apply Filters
        </button>
       
      </div> */}

      <DataTableReact
        data={users}
        columns={columns}
        renderRowActions={handleRenderRowActions}
        Pagination={Pagination}
        totalRows={totalRows}
        prevPageUrl={prevPageUrl}
        nextPageUrl={nextPageUrl}
        setPage={setPage}
        page={page}
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        loading={loading}
        moh={true}
        shouldShowActions={true}
      />

      {confirmationModal.action !== '' && (
        <ConfiramtionModal
          confirmationAction={confirmationModal}
          onClose={handleClose}
          onSubmit={handleSubmit}
        />
      )}
    </div>
  );
};

export default UserListing;

// <Nav tabs>
//     <NavItem>
//       <NavLink
//         className={activeTab === "all" ? "active" : ""}
//         style={{
//           position: "relative",
//           color: activeTab === "all" ? "gray" : "inherit",
//         }}
//         onClick={() => toggleTab("all")}
//       >
//         <span
//           style={{
//             display: "inline-flex",
//             alignItems: "center",
//             gap: "4px", // Adds spacing between name and badge
//           }}
//         >
//           All Users
//         </span>
//         {activeTab === "all" && (
//           <div
//             style={{
//               position: "absolute",
//               bottom: "-2px",
//               left: "0",
//               right: "0",
//               height: "2px",
//               backgroundColor: "gray",
//             }}
//           ></div>
//         )}
//       </NavLink>
//     </NavItem>

//   </Nav>
